import React from 'react'
import { useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import MappingForm from '../../components/MangeHKT/MappingForm'

function CreateMapping() {
    const navigate = useNavigate()
    // handleGoBack
    const handleGoBack = () => {
        navigate('/manage-requests')
    }

    // create action
    const handleForm = async (propsData) => {
        const { property, roomType, task, taskGroups, taskProcess, workStages } = propsData
        if (property) {
            try {
                const response = await nbrApi.get(`/createflatmap2?properties_id=${property}&ws_id=${workStages}&tp_id=${taskProcess}&tg_id=${taskGroups}&mririt_id=${task}&rt_id=${roomType}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Mapping created successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Mapping Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Mapping Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create new Mapping</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <MappingForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateMapping